import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <div className={`bg-card text-card-foreground rounded-lg border border-border shadow-sm ${className}`} data-id="element-121">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 ${className}`} data-id="element-122">{children}</div>;
}
export function CardTitle({
  children,
  className = ''
}: CardProps) {
  return <h3 className={`text-2xl font-semibold leading-none tracking-tight ${className}`} data-id="element-123">
      {children}
    </h3>;
}
export function CardDescription({
  children,
  className = ''
}: CardProps) {
  return <p className={`text-sm text-muted-foreground mt-1.5 ${className}`} data-id="element-124">
      {children}
    </p>;
}
export function CardContent({
  children,
  className = ''
}: CardProps) {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-125">{children}</div>;
}